import React, { Component } from 'react';
import { Modal, Image, Translate, Carousel } from '$common';
import Cookies from "js-cookie";
import CSSModules from 'react-css-modules';
import style from './tutorial.scss';



@CSSModules(style, { allowMultiple: true })
export default class Tutorial extends Component {
  state = {
    isOpen: false
  }

  componentWillMount() {
    if (Cookies.get('customer_signup')) {
      this.setState({ isOpen: true });
    }
  }

  closeModal() {
    this.setState({ isOpen: false });
    Cookies.remove('customer_signup');
  }

  render() {
    const { isOpen } = this.state;

    return (
      <Modal
        isOpen={isOpen}
        showHeader={false}
        padding={false}
        closable={false}
      >
        <Carousel
          items={[
            <div>
              <Image source={require('$shared/images/tutorial/1.png')}/>
              <h3>{Translate.get('tutorial_step_1_title')}</h3>
              <p>{Translate.get('tutorial_step_1_description')}</p>
            </div>,
            <div>
              <Image source={require('$shared/images/tutorial/2.png')}/>
              <h3>{Translate.get('tutorial_step_2_title')}</h3>
              <p>{Translate.get('tutorial_step_2_description')}</p>
            </div>,
            <div>
              <Image source={require('$shared/images/tutorial/3.png')}/>
              <h3>{Translate.get('tutorial_step_3_title')}</h3>
              <p>{Translate.get('tutorial_step_3_description')}</p>
            </div>
          ]}
          indicatorStyle={{ bottom: '-90px', left: '0px', right: '0px' }}
        />
        <div styleName="skip-btn">
          <span onClick={() => this.closeModal()}>{Translate.get('skip')}</span>
        </div>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/create/tutorial/tutorial.js